import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  
   @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 

  .generated-images-holder-var40 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var40 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }

  .texts-holder-var40 {
    width: 50%;
    position: relative;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
     &--more-width {
      width: 60%;
    }
}

  .middle-divider-var40 {
    position: absolute;
    left: 0;
    top: calc(50% - 2px);
    height: 3px;
    width: 100%;
    background-color: #b6c0c7
  }

  .left-image-var40 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    &--more-width {
      width: 40%;
    }
  }

  .author-row-var40 {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .author-name-var40 {
    font-weight: 700;
    font-size: 27px;
    color: #000;
    font-family: CustomArial;
  }

  .author-name-var40__blue {
    color: #3D5798;
  }

  .author-image-var40 {
    width: 74px;
    height: 74px;
    object-fit: cover;
    margin-right: 18px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .top-text-holder-var40, .bottom-text-holder-var40 {
    height: 50%;
    background-color: white;
    padding: 33px 31px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .left-text-holder-var40 {
    left: 0;
    right: auto;
  }

  .right-text-var40 {
    color: #1C2327;
    font-family: CustomArial;
    line-height: 1.2;
    p {
      display: inline;
    }
  }

  .actual-photo-var40 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    z-index: 1;
  }
  .actual-photo-var40--top {
    top: 0;
    bottom: auto;
  }

   .break-var40 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--more-width {
      margin-left: calc(40% - 6px);
    }
  }
 
`;

export default VariationsStyles;
